var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-info btn-xs btn-block",on:{"click":_vm.showAdministrationProductModal}},[_c('i',{staticClass:"fa fa-pen mr-2"}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('UpdateProductBtn.update'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }